module.exports = __webpack_public_path__ + "static/media/brand4-small.64fb47f0.jpg";